//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Returns list of all users (without patients).
 * @param ids (optional) Ids of users
 * @param searchQuery (optional) Search query string.
e.g. Mike - return all users which name or last name contains "Mike".
 * @param roles (optional) Filter for roles.
 * @param generalRoles (optional) Filter for general roles.
 * @param withoutStudy (optional) Filter for users who is not in any study.
 * @param predefinedUser (optional) Filter for users who was created manually for external auth.
 * @param studyIds (optional) List of study where users are present.
If "WithoutStudy" filter is ENABLED this filter will be ignored!
 * @param permissions (optional) List of permissions
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function getAllUsers(ids?: string[] | null | undefined, searchQuery?: string | null | undefined, roles?: string[] | null | undefined, generalRoles?: string[] | null | undefined, withoutStudy?: boolean | null | undefined, predefinedUser?: boolean | null | undefined, studyIds?: number[] | null | undefined, permissions?: Types.Permissions[] | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PagedResultOfStaffDto> {
    let url_ = getBaseUrl() + "/api/users?";
    if (ids !== undefined && ids !== null)
        ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
    if (searchQuery !== undefined && searchQuery !== null)
        url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
    if (roles !== undefined && roles !== null)
        roles && roles.forEach(item => { url_ += "Roles=" + encodeURIComponent("" + item) + "&"; });
    if (generalRoles !== undefined && generalRoles !== null)
        generalRoles && generalRoles.forEach(item => { url_ += "GeneralRoles=" + encodeURIComponent("" + item) + "&"; });
    if (withoutStudy !== undefined && withoutStudy !== null)
        url_ += "WithoutStudy=" + encodeURIComponent("" + withoutStudy) + "&";
    if (predefinedUser !== undefined && predefinedUser !== null)
        url_ += "PredefinedUser=" + encodeURIComponent("" + predefinedUser) + "&";
    if (studyIds !== undefined && studyIds !== null)
        studyIds && studyIds.forEach(item => { url_ += "StudyIds=" + encodeURIComponent("" + item) + "&"; });
    if (permissions !== undefined && permissions !== null)
        permissions && permissions.forEach(item => { url_ += "Permissions=" + encodeURIComponent("" + item) + "&"; });
    if (offset !== undefined && offset !== null)
        url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
        url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    if (sortBy !== undefined && sortBy !== null)
        url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (sortOrder === null)
        throw new Error("The parameter 'sortOrder' cannot be null.");
    else if (sortOrder !== undefined)
        url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetAllUsers,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetAllUsers(_response);
    });
}

function processGetAllUsers(response: AxiosResponse): Promise<Types.PagedResultOfStaffDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.PagedResultOfStaffDto.fromJS(resultData200);
        return Promise.resolve<Types.PagedResultOfStaffDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PagedResultOfStaffDto>(null as any);
}

/**
 * Creates user with predefined email for further log in and assignment for study.
 * @param dto user information DTO.
 */
export function createUser(dto: Types.CreatePredefinedUserDto, config?: AxiosRequestConfig | undefined): Promise<Types.StaffDto> {
    let url_ = getBaseUrl() + "/api/users";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateUser,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateUser(_response);
    });
}

function processCreateUser(response: AxiosResponse): Promise<Types.StaffDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.StaffDto.fromJS(resultData200);
        return Promise.resolve<Types.StaffDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.StaffDto>(null as any);
}

/**
 * Creates user with predefined email for further log in and assignment for study.
 * @param data List of users with their information DTO.
 */
export function createUsers(data: Types.CreatePredefinedUserDto[], config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/users/batch";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(data);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateUsers,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateUsers(_response);
    });
}

function processCreateUsers(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Change Identity roles of user by Id.
All not provided roles - will be removed from user store.
 * @param id Id of the user.
 * @param roles List with new Identity roles.
 */
export function changeUserGeneralRoles(id: string, roles: string[], config?: AxiosRequestConfig | undefined): Promise<Types.StaffDto> {
    let url_ = getBaseUrl() + "/api/users/{id}/Roles";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(roles);

    let options_: AxiosRequestConfig = {
        ..._requestConfigChangeUserGeneralRoles,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processChangeUserGeneralRoles(_response);
    });
}

function processChangeUserGeneralRoles(response: AxiosResponse): Promise<Types.StaffDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.StaffDto.fromJS(resultData200);
        return Promise.resolve<Types.StaffDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.StaffDto>(null as any);
}

/**
 * Change Study roles of user by Id.
All not provided roles - will be removed from user store.
 * @param id Id of the user.
 * @param roleIds List with new Study roles.
 * @param studyId (optional) Id of the user.
 */
export function changeUserStudyRoles(id: string, roleIds: string[], studyId?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.StaffDto> {
    let url_ = getBaseUrl() + "/api/users/{id}/StudyRoles?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (studyId === null)
        throw new Error("The parameter 'studyId' cannot be null.");
    else if (studyId !== undefined)
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(roleIds);

    let options_: AxiosRequestConfig = {
        ..._requestConfigChangeUserStudyRoles,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processChangeUserStudyRoles(_response);
    });
}

function processChangeUserStudyRoles(response: AxiosResponse): Promise<Types.StaffDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.StaffDto.fromJS(resultData200);
        return Promise.resolve<Types.StaffDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.StaffDto>(null as any);
}

/**
 * Change tag filters of the user with the specified id
 * @param id The id of the user to update
 * @param studyId (optional) 
 * @param tagFilters (optional) New tag filters
 */
export function changeUserTagFilters(id: string, studyId?: number | undefined, tagFilters?: { [key: string]: string[]; } | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.StaffDto> {
    let url_ = getBaseUrl() + "/api/users/{id}/TagFilters?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (studyId === null)
        throw new Error("The parameter 'studyId' cannot be null.");
    else if (studyId !== undefined)
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(tagFilters);

    let options_: AxiosRequestConfig = {
        ..._requestConfigChangeUserTagFilters,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processChangeUserTagFilters(_response);
    });
}

function processChangeUserTagFilters(response: AxiosResponse): Promise<Types.StaffDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.StaffDto.fromJS(resultData200);
        return Promise.resolve<Types.StaffDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.StaffDto>(null as any);
}

/**
 * Assign doctor to the specific study.
 * @param id Id of teh doctor.
 * @param studyId (optional) Study Id that user will be assigned.
 */
export function assignToStudy(id: string, studyId?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/users/{id}/assign?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (studyId === null)
        throw new Error("The parameter 'studyId' cannot be null.");
    else if (studyId !== undefined)
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigAssignToStudy,
        ...config,
        method: "POST",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAssignToStudy(_response);
    });
}

function processAssignToStudy(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Unassign study for a doctor
 * @param id Id of teh doctor.
 * @param studyId (optional) Study Id that will be unassigned.
 */
export function unassignStudy(id: string, studyId?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/users/{id}/unassign?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (studyId === null)
        throw new Error("The parameter 'studyId' cannot be null.");
    else if (studyId !== undefined)
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigUnassignStudy,
        ...config,
        method: "PATCH",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processUnassignStudy(_response);
    });
}

function processUnassignStudy(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function patchUser(id: string, dto: Types.PatchUserDto, config?: AxiosRequestConfig | undefined): Promise<Types.StaffDto> {
    let url_ = getBaseUrl() + "/api/users/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPatchUser,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPatchUser(_response);
    });
}

function processPatchUser(response: AxiosResponse): Promise<Types.StaffDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.StaffDto.fromJS(resultData200);
        return Promise.resolve<Types.StaffDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.StaffDto>(null as any);
}

export function deleteUser(id: string, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/users/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigDeleteUser,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processDeleteUser(_response);
    });
}

function processDeleteUser(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigGetAllUsers: Partial<AxiosRequestConfig> | null;
export function getGetAllUsersRequestConfig() {
  return _requestConfigGetAllUsers;
}
export function setGetAllUsersRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetAllUsers = value;
}
export function patchGetAllUsersRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetAllUsers = patch(_requestConfigGetAllUsers ?? {});
}

let _requestConfigCreateUser: Partial<AxiosRequestConfig> | null;
export function getCreateUserRequestConfig() {
  return _requestConfigCreateUser;
}
export function setCreateUserRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateUser = value;
}
export function patchCreateUserRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateUser = patch(_requestConfigCreateUser ?? {});
}

let _requestConfigCreateUsers: Partial<AxiosRequestConfig> | null;
export function getCreateUsersRequestConfig() {
  return _requestConfigCreateUsers;
}
export function setCreateUsersRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateUsers = value;
}
export function patchCreateUsersRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateUsers = patch(_requestConfigCreateUsers ?? {});
}

let _requestConfigChangeUserGeneralRoles: Partial<AxiosRequestConfig> | null;
export function getChangeUserGeneralRolesRequestConfig() {
  return _requestConfigChangeUserGeneralRoles;
}
export function setChangeUserGeneralRolesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigChangeUserGeneralRoles = value;
}
export function patchChangeUserGeneralRolesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigChangeUserGeneralRoles = patch(_requestConfigChangeUserGeneralRoles ?? {});
}

let _requestConfigChangeUserStudyRoles: Partial<AxiosRequestConfig> | null;
export function getChangeUserStudyRolesRequestConfig() {
  return _requestConfigChangeUserStudyRoles;
}
export function setChangeUserStudyRolesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigChangeUserStudyRoles = value;
}
export function patchChangeUserStudyRolesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigChangeUserStudyRoles = patch(_requestConfigChangeUserStudyRoles ?? {});
}

let _requestConfigChangeUserTagFilters: Partial<AxiosRequestConfig> | null;
export function getChangeUserTagFiltersRequestConfig() {
  return _requestConfigChangeUserTagFilters;
}
export function setChangeUserTagFiltersRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigChangeUserTagFilters = value;
}
export function patchChangeUserTagFiltersRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigChangeUserTagFilters = patch(_requestConfigChangeUserTagFilters ?? {});
}

let _requestConfigAssignToStudy: Partial<AxiosRequestConfig> | null;
export function getAssignToStudyRequestConfig() {
  return _requestConfigAssignToStudy;
}
export function setAssignToStudyRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAssignToStudy = value;
}
export function patchAssignToStudyRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAssignToStudy = patch(_requestConfigAssignToStudy ?? {});
}

let _requestConfigUnassignStudy: Partial<AxiosRequestConfig> | null;
export function getUnassignStudyRequestConfig() {
  return _requestConfigUnassignStudy;
}
export function setUnassignStudyRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigUnassignStudy = value;
}
export function patchUnassignStudyRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigUnassignStudy = patch(_requestConfigUnassignStudy ?? {});
}

let _requestConfigPatchUser: Partial<AxiosRequestConfig> | null;
export function getPatchUserRequestConfig() {
  return _requestConfigPatchUser;
}
export function setPatchUserRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPatchUser = value;
}
export function patchPatchUserRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPatchUser = patch(_requestConfigPatchUser ?? {});
}

let _requestConfigDeleteUser: Partial<AxiosRequestConfig> | null;
export function getDeleteUserRequestConfig() {
  return _requestConfigDeleteUser;
}
export function setDeleteUserRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigDeleteUser = value;
}
export function patchDeleteUserRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigDeleteUser = patch(_requestConfigDeleteUser ?? {});
}